"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _swatchesModule = _interopRequireDefault(require("./swatches.module.scss"));
var _getProductUrl = _interopRequireDefault(require("../../../utils/product/getProductUrl"));
var _scene7UrlParser = require("../../../utils/scene7/scene7UrlParser");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var Swatches = /*#__PURE__*/function (_PureComponent) {
  _inherits(Swatches, _PureComponent);
  function Swatches() {
    var _this;
    _classCallCheck(this, Swatches);
    _this = _callSuper(this, Swatches);
    _this.state = {
      showMoreAvailable: false
    };
    _this.checkShowMoreAvailable = _this.checkShowMoreAvailable.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Swatches, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var swatches = this.props.swatches;
      if (!swatches || !swatches.length || swatches.length === 1) {
        return;
      }
      this.checkShowMoreAvailable();
      window.addEventListener('resize', (0, _debounce["default"])(this.checkShowMoreAvailable, 150));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', (0, _debounce["default"])(this.checkShowMoreAvailable, 150));
    }
  }, {
    key: "checkShowMoreAvailable",
    value: function checkShowMoreAvailable() {
      var swatches = this.props.swatches;
      if (!swatches || !this.swatchList || !this.swatchItem) {
        return;
      }
      var swatchListWidth = this.swatchList.clientWidth;
      var swatchItemWidth = this.swatchItem.clientWidth;
      var maxSwatches = swatchListWidth / swatchItemWidth;
      this.setState({
        showMoreAvailable: swatches.length > maxSwatches
      });
    }
  }, {
    key: "handleHover",
    value: function handleHover(isHovering) {
      var setIsQvDrawerForcedClosed = this.props.setIsQvDrawerForcedClosed;
      if (setIsQvDrawerForcedClosed) {
        setIsQvDrawerForcedClosed(isHovering);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var showMoreAvailable = this.state.showMoreAvailable;
      var _this$props = this.props,
        swatches = _this$props.swatches,
        title = _this$props.title,
        id = _this$props.id,
        baseUrl = _this$props.baseUrl,
        handleClick = _this$props.handleClick,
        _this$props$imageLoad = _this$props.imageLoading,
        imageLoading = _this$props$imageLoad === void 0 ? 'lazy' : _this$props$imageLoad,
        isListViewOn = _this$props.isListViewOn,
        className = _this$props.className,
        selectedSwatch = _this$props.selectedSwatch,
        swatchImpressionsHashValue = _this$props.swatchImpressionsHashValue;
      if (!swatches || !swatches.length || swatches.length === 1) {
        return '';
      }
      var getSwatchUrl = function getSwatchUrl(title, id, swatch) {
        var swatchUrl = swatch.url || (0, _getProductUrl["default"])(title, id, swatch);
        return swatchImpressionsHashValue ? "".concat(swatchUrl, "#").concat(swatchImpressionsHashValue) : swatchUrl;
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames4["default"])(_swatchesModule["default"].swatches, className, _defineProperty({}, _swatchesModule["default"]['list-view'], isListViewOn)),
        onMouseEnter: function onMouseEnter() {
          return _this2.handleHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.handleHover(false);
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _swatchesModule["default"].visuallyHidden,
          children: "View this product in other colours by selecting one of the following:"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          className: (0, _classnames4["default"])(_swatchesModule["default"].swatchesList, _defineProperty({}, _swatchesModule["default"]['swatchesList--padding-below'], showMoreAvailable)),
          ref: function ref(swatchList) {
            _this2.swatchList = swatchList;
          },
          children: swatches.map(function (swatch, i) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: (0, _classnames4["default"])(_swatchesModule["default"].swatchItem, _defineProperty(_defineProperty({}, _swatchesModule["default"].unavailable, !swatch.isAvailable), _swatchesModule["default"]['swatchItem--selected'], (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.color) === swatch.color || !(selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color) && i === 0)),
              ref: function ref(swatchItem) {
                _this2.swatchItem = swatchItem;
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
                "data-test": "swatch-button",
                title: "".concat(swatch.color).concat(swatch.isAvailable ? '' : ' - Out of stock'),
                tabIndex: "0",
                onClick: handleClick,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: (0, _scene7UrlParser.setScene7UrlQueryParams)(swatch.colorSwatchUrl, {
                    wid: '18',
                    hei: '18',
                    fit: 'crop'
                  }),
                  alt: "".concat(swatch.color, " ").concat(swatch.isAvailable ? '' : ' - Out of stock'),
                  loading: imageLoading
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  className: _swatchesModule["default"].visuallyHidden,
                  children: ["This colour is", ' ', swatch.isAvailable ? 'available' : 'unavailable']
                })]
              })
            }, swatch.skuId);
          })
        }), showMoreAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          className: _swatchesModule["default"].moreColours,
          href: baseUrl || (0, _getProductUrl["default"])(title, id),
          children: "+ More colours available"
        }) : '']
      });
    }
  }]);
  return Swatches;
}(_react.PureComponent);
var _default = exports["default"] = Swatches;